import React from 'react';
import { cx } from '../cx';

// D-09 §15.2 — Select (.field > label + .select + .help)
export interface SelectProps extends Omit<React.SelectHTMLAttributes<HTMLSelectElement>, 'size'> {
  label?: string;
  error?: string;
  size?: 'sm' | 'md' | 'lg';
}

export function Select({ label, error, size = 'md', className = '', id, children, ...props }: SelectProps) {
  return (
    <div className={cx('field', error && 'error', className)}>
      {label && <label htmlFor={id}>{label}</label>}
      <select id={id} className={cx('select', size !== 'md' && `select-${size}`)} {...props}>
        {children}
      </select>
      {error && <span className="help">{error}</span>}
    </div>
  );
}
